import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { getReviewsSummary } from "../lib/api";
import { GCARD_COPY } from "../i18n/homeContentI18n";

export const GOOGLE_REVIEW_URL = "https://www.google.com/maps?cid=8059183557833479690";

// Official multi-colour Google "G" mark.
export const GoogleG = ({ className = "w-5 h-5" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
  </svg>
);

const T_DE = { title: "Bewerten Sie uns auf Google", sub: "Ihre Meinung hilft uns weiter.", cta: "Auf Google bewerten", based: "aus {n} Bewertungen" };

export const GoogleProfileCard = () => {
  const { lang } = useLang();
  const t = lang === "de" ? T_DE : (GCARD_COPY[lang] || GCARD_COPY.en);
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    getReviewsSummary().then((s) => setSummary(s)).catch(() => setSummary(null));
  }, []);

  const avg = summary && summary.count > 0 ? Number(summary.average) : 5;
  const count = summary && summary.count > 0 ? summary.count : null;

  return (
    <a
      href={GOOGLE_REVIEW_URL}
      target="_blank"
      rel="noreferrer"
      data-testid="google-profile-card"
      className="group mt-4 flex items-center gap-4 rounded-2xl bg-white border border-neutral-200 shadow-sm hover:shadow-md hover:border-[#4285F4]/40 px-5 py-4 transition-all"
    >
      <span className="grid place-items-center w-12 h-12 rounded-full bg-neutral-50 border border-neutral-200 shrink-0">
        <GoogleG className="w-6 h-6" />
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className="text-sm font-bold text-neutral-900 truncate">{t.title}</span>
        </div>
        <div className="mt-0.5 flex items-center gap-2">
          <span className="text-sm font-bold text-neutral-900">{avg.toFixed(1)}</span>
          <span className="flex gap-0.5">
            {[1, 2, 3, 4, 5].map((n) => (
              <Star key={n} className={`w-3.5 h-3.5 ${n <= Math.round(avg) ? "fill-[#FBBC05] text-[#FBBC05]" : "text-neutral-300"}`} />
            ))}
          </span>
          {count ? <span className="text-xs text-neutral-500 truncate">{t.based.replace("{n}", count)}</span> : null}
        </div>
      </div>
      <span className="hidden sm:inline-flex items-center rounded-full border border-neutral-300 group-hover:border-[#4285F4] group-hover:bg-[#4285F4]/5 px-4 py-2 text-xs font-semibold text-neutral-800 transition-colors shrink-0" data-testid="google-profile-cta">
        {t.cta}
      </span>
    </a>
  );
};

export default GoogleProfileCard;
